module.exports = __webpack_public_path__ + "static/img/Captura2.eb23a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Captura2.png
// module id = JCju
// module chunks = 1